const getFlatsWithProperties = flats => {
  if (!flats) return null;

  return [
    ...flats.map(flat => {
      return {
        investment: 'Yacht Apartment',
        name: flat.lokal,
        price: flat.CENA ? Math.floor(flat.CENA) : 0,
        isPriceVisible: false,
        type: 'flat',
        area: Number(flat.metraz).toFixed(2),
        floor: flat.pietro,
        rooms: flat.pokoje,
        balcony: (flat.balkon && Number(flat.balkon).toFixed(2)) || null,
        garden: (flat.ogrodek && Number(flat.ogrodek).toFixed(2)) || null,
        loggia: (flat.loggia && Number(flat.loggia).toFixed(2)) || null,
        patio: (flat.patio && Number(flat.patio).toFixed(2)) || null,
        status: Number(flat.status),
        building: 'M',
        PNG: `https://hosting2108408.online.pro/flats/PNG/${flat.lokal}.png`,
        PDF: `https://hosting2108408.online.pro/flats/PDF/${flat.lokal}.pdf`,
      };
    }),
    {
      investment: 'Yacht Apartment',
      name: 'pool',
      type: 'local',
      price: null,
      isPriceVisible: false,
      area: 188.27,
      floor: 0,
      rooms: null,
      balcony: null,
      garden: null,
      loggia: null,
      patio: null,
      status: null,
      building: 'M',
      PNG: `https://hosting2108408.online.pro/flats/PNG/basen.png`,
      PDF: `https://hosting2108408.online.pro/flats/PDF/basen.pdf`,
    },
    {
      investment: 'Yacht Apartment',
      name: 'lobby',
      type: 'local',
      price: null,
      isPriceVisible: false,
      area: 63.09,
      floor: 0,
      rooms: null,
      balcony: null,
      garden: null,
      loggia: null,
      patio: null,
      status: null,
      building: 'M',
      PNG: `https://hosting2108408.online.pro/flats/PNG/lobby.png`,
      PDF: `https://hosting2108408.online.pro/flats/PDF/lobby.pdf`,
    },
  ];
};

export default getFlatsWithProperties;
